import React from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'
import ArtDirectingImage from '../shared/ArtDirectingImage'
import { desktopVW } from '../../styles'

const CollectionBanner = ({
  bannerCopy,
  bannerImageDesktop,
  bannerImageMobile,
  heroCopy1,
  heroCopy2,
  heroCopyColor1,
  heroCopyColor2,
  alternativeLayout,
}) => {
  return (
    <StyledBanner>
      <StyledImage
        fluid={ArtDirectingImage(
          bannerImageMobile.fluid,
          bannerImageDesktop.fluid,
        )}
        alt={bannerImageMobile.title}
        loading='eager'
      />

      {alternativeLayout ? (
        <AltCopy>
          <CopyOne>{bannerCopy}</CopyOne>
          <CopyTwoContainer>
            <CopyTwo>{heroCopy1}</CopyTwo>
            <CopyThree>{heroCopy2}</CopyThree>
          </CopyTwoContainer>
        </AltCopy>
      ) : !bannerCopy ? (
        <Copy>
          <CopyColor color={heroCopyColor1}>{heroCopy1}</CopyColor>
          <br />
          <CopyColor color={heroCopyColor2} small>
            {heroCopy2}
          </CopyColor>
        </Copy>
      ) : (
        <Copy>{bannerCopy}</Copy>
      )}
    </StyledBanner>
  )
}

const AltCopy = styled.div`
  position: absolute;
  inset: 0;
`

const CopyOne = styled.div`
  position: absolute;
  font-family: AkiraExpanded;
  color: white;
  font-size: ${desktopVW(93, 1000)};
  width: 70vw;
  transform: translateX(50%);
  right: 50%;
  top: ${desktopVW(179, 1000)};
  text-align: center;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${desktopVW(104, 2560)};
    width: 30vw;
    bottom: 50%;
    left: 1vw;
    top: unset;
    right: unset;
    transform: translateY(50%);
  }
`
const CopyTwoContainer = styled.div`
  position: absolute;
  text-align: right;
  bottom: ${desktopVW(129, 1000)};
  left: ${desktopVW(40, 1000)};
  font-family: AkiraExpanded;
  font-size: ${desktopVW(91, 1000)};
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${desktopVW(104, 2560)};
    bottom: ${desktopVW(76, 2560)};
    right: ${desktopVW(46, 2560)};
    left: unset;
  }
`

const CopyTwo = styled.div`
  -webkit-text-stroke: 1.5px red;
  color: transparent;
  letter-spacing: 6%;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    -webkit-text-stroke: 2px red;
  }
`
const CopyThree = styled.div`
  color: #ff1e00;
  letter-spacing: 6%;
`

const CopyColor = styled.span`
  color: ${({ color }) => color || 'white'};
  font-size: ${({ small }) => (small ? '9vw' : 'inherit')};
  line-height: ${({ small }) => (small ? 'inherit' : '14vw')};

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${({ small }) => (small ? '4.5vw' : 'inherit')};
    line-height: ${({ small }) => (small ? 'inherit' : '6.7vw')};
  }
`

const StyledBanner = styled.section`
  width: 100vw;
  position: relative;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 27vw;
    margin-bottom: ${(props) => props.theme.space.marginDesktop * 4}vw;
  }
`

const StyledImage = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: auto;
  }
`

const Copy = styled.h1`
  position: absolute;
  left: 50%;
  bottom: 17.5%;
  transform: translateX(-50%);
  font-size: 11.3vw;
  color: white;
  line-height: 12vw;
  text-align: center;
  width: 90vw;
  /* Black Friday */
  text-shadow: 5px 1px 12px #0000007d;
  /* .end Black Friday */

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 5.9vw;
    line-height: 5.5vw;
    text-align: left;
    padding-left: ${(props) => props.theme.space.marginDesktop * 8}vw;
    width: 50vw;
    top: 50%;
    left: 0;
    bottom: auto;
    transform: translateY(-50%);
  }
`

export default CollectionBanner
